import { Badge, Tooltip } from 'antd';
import { React } from 'react';
import { REQUIREMENT_OPTIONS } from '../../../../utils/const/mapping';

export const getAttributesColumns = () => [
  {
    title: 'Nom',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => {
      const nameA = a.name || '';
      const nameB = b.name || '';
      return nameA.localeCompare(nameB);
    },
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    sorter: (a, b) => {
      const codeA = a.code || '';
      const codeB = b.code || '';
      return codeA.localeCompare(codeB);
    },
  },
  {
    title: 'Exigence',
    dataIndex: 'requirement',
    key: 'requirement',
    sorter: (a, b) => {
      const order = {
        required: 0,
        recommended: 1,
        optional: 2,
        not_provided: 3,
      };
      const orderA = order[a.requirement] ?? 4;
      const orderB = order[b.requirement] ?? 4;
      return orderA - orderB;
    },
    render: (_, record) => {
      if (!record.requirementInfo) {
        return <span style={{ color: '#bababa' }}>-</span>;
      }

      return (
        <Badge
          color={record.requirementInfo.color}
          text={
            <Tooltip
              title={record.requirementInfo.label}
              color={record.requirementInfo.color}
              placement="left"
            >
              {record.requirementInfo.label}
            </Tooltip>
          }
        />
      );
    },
  },
];

export const formatAttributeData = (attributes) => {
  if (!attributes || attributes.length === 0) return [];

  return attributes.map((attr) => {
    const requirementInfo = REQUIREMENT_OPTIONS.find(
      (opt) => opt.name === attr.requirement
    );

    return {
      key: attr.id.toString(),
      id: attr.id,
      code: attr.code,
      name: attr.name,
      requirement: attr.requirement,
      requirementInfo,
    };
  });
};
